<div class="container">
  <div class="col-3">
    <div class="flex flex-column" >
      <div class="label-text">{{'ExporterInfoModal.CompanyNameText' | translate}}</div>
      <div class="info-div border-round-sm">
        <app-text-preview-tooltip
          [text]="exporterInfo?.companyName"
          [maxWidth]="200"
          >
        </app-text-preview-tooltip>
      </div>
    </div>
  </div>
  <div class="col-3">
    <div class="flex flex-column" >
      <div class="label-text">{{'ExporterInfoModal.ContactAddressText' | translate}}</div>
      <div class="info-div border-round-sm">
        <app-text-preview-tooltip
          [text]="exporterInfo?.contactAddress"
          [maxWidth]="200"
          >
        </app-text-preview-tooltip>
      </div>
    </div>
  </div>
  <div class="col-3">
    <div class="flex flex-column" >
      <div class="label-text">{{'ExporterInfoModal.ContactEmailText' | translate}}</div>
      <div class="info-div border-round-sm">
        <app-text-preview-tooltip
          [text]="exporterInfo?.contactEmail"
          [maxWidth]="200"
          >
        </app-text-preview-tooltip>
      </div>
    </div>
  </div>
  <div class="col-3">
    <div class="flex flex-column" >
      <div class="label-text">{{'ExporterInfoModal.CompanyNRegText' | translate}}</div>
      <div class="info-div border-round-sm">
        <app-text-preview-tooltip
          [text]="exporterInfo?.vat"
          [maxWidth]="200"
          >
        </app-text-preview-tooltip>
      </div>
    </div>
  </div>
    <!-- <div class="col-4">
        <div class="flex flex-column" >
            <div class="label-text">Usuario fruzty por compañía</div>
            <div class="info-div border-round-sm">Av 123, casa 123</div>
        </div>
    </div> -->
</div>
